import { useSessionStorage, tryOnMounted } from '@vueuse/core'

type UseRefererParams = { bid?: number; pid?: number }

function useRefererSession(key: string) {
  const route = useRoute()
  const refererSession = useSessionStorage<string | null>(key, null)

  tryOnMounted(() => {
    const referer = route.query.referer as string
    if (!referer) {
      return
    }
    refererSession.value = referer
  })

  function deleteReferer() {
    refererSession.value = null
  }

  return {
    refererSession,
    deleteReferer,
  }
}

/* branch and product 頁傳進 either bid or pid, preview and remark 頁傳進 both bid and pid   */
export function useReferer({ bid, pid }: UseRefererParams) {
  const route = useRoute()
  const router = useRouter()
  const bidReferer = useRefererSession(`referer-bid-${bid}`)
  const pidReferer = useRefererSession(`referer-pid-${pid}`)

  const referer = computed(() => {
    return bidReferer.refererSession.value || pidReferer.refererSession.value || ''
  })

  tryOnMounted(() => {
    if (!bid) bidReferer.deleteReferer()
    if (!pid) pidReferer.deleteReferer()
    const { referer: routeQuery, ...restQuery } = route.query
    if (routeQuery) {
      router.replace({ query: restQuery }).catch(err => console.error(err))
    }
  })

  function deleteReferer() {
    bidReferer.deleteReferer()
    pidReferer.deleteReferer()
  }

  return { referer, deleteReferer }
}
